import { StoreData } from "./store.data";

export type SourceBalanceModelVersion = 1;

/** Vault source row for a Fiskil balance snapshot (per account, per retrieval). */
export interface SourceBalanceStoreModel extends StoreData {
  v: SourceBalanceModelVersion;

  /** Gloss account id (Book id) */
  acId: string;

  /** ISO date-time when this balance snapshot was recorded (semantic “balance time”). */
  bDt: string;

  /** Raw JSON string of the Fiskil balance object */
  rw: string;
}

export const DefaultSourceBalanceStoreModel: SourceBalanceStoreModel = {
  acId: "",
  bDt: "",
  rw: "",
  dc: "",
  dm: "",
  id: "",
  v: 1,
  vid: "",
};
